import React, {useContext, useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import userContext from "../../../../context/user-context";
import Get from "../../../Utils/API/Get";

import SubAccountTable from "./Table/SubAccountsTable";
import Auxiliary from "../../../../hoc/Auxiliary";
import {Spinner} from "reactstrap";

const getSubAccounts = async () => {
    const queryJson = {};
    try {
        const subAccounts = await Get({
            endpoint: "/accounts/subaccounts",
            queryJson,
        });
        if (!subAccounts) {
            return false;
        }
        return subAccounts;
    } catch (e) {
        console.error(e.message);
        return false;
    }
};

const mapSubAccount = (subAccount) => {
    return {
        ...subAccount,
        checkBox: subAccount.subAccountCode,
    };
};

const SubAccounts = (props) => {
    const { user } = useContext(userContext);
    const { t, i18n } = useTranslation();
    const [subAccounts, setSubAccounts] = useState([]);
    const [pages, setPages] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        user &&
            getSubAccounts().then((subAccounts) => {
                const mappedSubAccounts = subAccounts.data.map(mapSubAccount);
                setSubAccounts(mappedSubAccounts);
                setPages(subAccounts.totalPages);
                setLoading(false);

                if (props.selectedValues && props.selectedValues.length > 0) {
                    const formattedValues = props.selectedValues.map(val => val.toString());
                    setChecked(formattedValues);
                } else {
                    setChecked([]);
                }
            });
    }, [user]);

    const [checked, setChecked] = useState([]);
    const [checkedNames, setCheckedNames] = useState([]);

    useEffect(() => {
        if (props.selectedValues && props.selectedValues.length > 0) {
            setChecked(props.selectedValues);
        }
    }, [props.selectedValues]);

    const handleCheck = (isChecked, value, accountName) => {
        let checkedItems = [];
        let checkedItemsNames = [];

        if (isChecked && !checked.includes(value)) {
            checkedItems = [
                ...checked.filter((thisChecked) => thisChecked !== value),
                value,
            ]
            checkedItemsNames = [
                ...checkedNames.filter((thisChecked) => thisChecked !== accountName),
                accountName
            ];
            setChecked(checkedItems);
            setCheckedNames(checkedItemsNames);
        } else {
            checkedItems = checked.filter((thisChecked) => thisChecked !== value)
            checkedItemsNames = checkedNames.filter((thisChecked) => thisChecked !== accountName)
            setChecked(checkedItems);
            setCheckedNames(checkedItemsNames);
        }

        props.onCheck(checkedItems, checkedItemsNames);
    };

    const columns = useMemo(
        () => [
            {
                accessor: "checkBox",
                Cell: (props) => {
                    return (
                        <div className="form-check flex flex-row justify-content-end">
                            <input
                                type="checkbox"
                                value={props.value}
                                name="subAccounts"
                                className="form-check-input"
                                onChange={(v) => {
                                    handleCheck(
                                        v.target.checked,
                                        v.target.value,
                                        props.row.cells[3].value
                                    );
                                }}
                                checked={checked.some(item => item.toString() === props.value.toString())}
                            ></input>
                        </div>
                    );
                },
                disableSortBy: true,
            },
            {
                Header: t('profile.assignments.form.subaccounts.list.header.type'),
                accessor:
                    i18n.language === "fr"
                        ? "subAccountType.descriptionFr"
                        : "subAccountType.descriptionEn",
                Cell: (props) => {
                    return props.value ? <span>{props.value}</span> : "";
                },
            },
            {
                Header: t('profile.assignments.form.subaccounts.list.header.number'),
                accessor: "subAccountCode",
                Cell: (props) => {
                    return (
                        <strong>
                            {props.value}
                        </strong>
                    );
                },
            },
            {
                Header: t('profile.assignments.form.subaccounts.list.header.name'),
                accessor: "subAccountName",
                Cell: (props) => {
                    return (
                        <strong>
                            {props.value}
                        </strong>
                    );
                },
            },
            {
                Header: t('profile.assignments.form.subaccounts.list.header.address'),
                accessor: 'address',
                Cell: (props) => {
                    let html = (
                        <Auxiliary>
                             {props.value.addressLine1} <br/>
                             {props.value.addressLine2 ? <>{props.value.addressLine2}<br/></> : ''}
                             {props.value.city} <br/>
                             {props.value.postalCode},{props.value.stateOrProvinceCode}
                         </Auxiliary>
                    );
                    return html;
                }
            }
        ],
        [t, i18n, checked]
    );

    return (
        <div>
            <div className="container container--larger flex nopadding">
                <div className="row">
                    <div className="col-12"></div>
                </div>
            </div>
            <SubAccountTable
                columns={columns}
                data={subAccounts}
                pageCount={pages}
                loading={loading}
                checked={checked}
            />
        </div>
    );
};

export default SubAccounts;
